import React from 'react'
import './css/Grid1.css'
function LoginButton(x) {
    if ({x}) {
        return (
            <p className="pop">NEW</p>
          );
    }
    else{
        return(
            <p>fzee</p>
        );
    }
  }
function Grid1({id,img,text,colors,on}) {
    if (on==true) {
        return (
            <div className="box">
                <div className="Grid">
                    <div className="center">
                        <img src={img}/>
                        <p style={{color: `${colors}`}}>{text}</p>
                    </div>
                    <p className="pop">NEW</p>
                </div>
            </div>
        )
    }
    else{
        return (
            <div className="box">
                <div className="Grid">
                    <div className="center">
                        <img src={img}/>
                        <p style={{color: `${colors}`}}>{text}</p>
                    </div>                    
                </div>
            </div>
        )
    }
}


export default Grid1
